module.exports = __webpack_public_path__ + "img/union.7c146793.png";